// eslint-disable-next-line import/no-unresolved
import PropTypes from 'prop-types';
import React from 'react';

export const WebcamIframe = ({
  src,
  title,
  disabled = false,
}) => (
  <iframe
    src={src}
    title={title}
    allow="autoplay; picture-in-picture; fullscreen"
    allowFullScreen
    tabIndex={disabled ? -1 : undefined}
  />
);

WebcamIframe.propTypes = {
  src: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
};
